import React, { useEffect } from 'react';
import { useAsyncValue, useNavigate, useSubmit } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Components Styled
import { Container, DuplicateTag } from './styles';

//Components

// Utils
import { createFormDataFromValues } from '../../../../../utils/forms';

// Types and Const
import NewCommunicationForm from '../../../../../components/forms/NewCommunicationForm';
import { NewCommunication } from '../../../../../types/communication';
import { formNaming } from '../../../../../components/forms/NewCommunicationForm/constants';
import { variant } from '../../../../../components/display/SpecialTag/types';

// Store
import { tabsType } from '../../../../../state/reducers/ui/tabs';
import { selectedRowModalTable } from '../../../../../state/actions/ui/selectRowTableModal';
import { tabs } from '../../../../../state/actions/ui/tabs';

export default function NewCommunicationPage(): JSX.Element {
  const loaderData = useAsyncValue() as NewCommunication & {
    relatedOrderData?: any;
  };
  const submit = useSubmit();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Initialize Redux with related OT/Campaign data if it exists
  useEffect(() => {
    if (loaderData.relatedOrderData && loaderData.parentOrderType) {
      let formKey = null;
      let tabIndex = 0;

      if (loaderData.parentOrderType === 'generic') {
        formKey = formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT;
        tabIndex = 1; // "Relacionar con O.T." tab
      } else if (loaderData.parentOrderType === 'campaign') {
        formKey = formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN;
        tabIndex = 2; // "Relacionar con Campaña" tab
      }

      if (formKey) {
        // Enrich parent's display data with communication's own classification/predefinido
        // relatedOrderData has parent's capitolId/subCapitolId, but NOT the communication's
        // independent classification/predefinedOrder (T36). Add them so CreateOT auto-fill works.
        const enrichedRelatedData = {
          ...loaderData.relatedOrderData,
          data: {
            ...loaderData.relatedOrderData?.data,
            classificationId: loaderData.classification,
            predefinedOrderId: loaderData.predefine,
          }
        };
        dispatch(selectedRowModalTable(formKey, enrichedRelatedData));
        // Set the active tab to show the related O.T. or Campaign
        dispatch(tabs(tabsType.DUPLICATE_COMMUNICATION, tabIndex));
      }
    }
  }, [loaderData.relatedOrderData, loaderData.parentOrderType, dispatch]);

  const onFormSubmit = async (values: NewCommunication) => {
    const formData = createFormDataFromValues(values);
    submit(formData, {
      method: 'POST',
      action: '../summary',
    });
  };

  const closeTab = () => {
    sessionStorage.removeItem(formNaming.NEW_DUPLICATE_COMMUNICATION_FORM);
    navigate('..');
  };

  return (
    <Container>
      <DuplicateTag variant={variant.Duplicate} onClick={closeTab} />
      <NewCommunicationForm
        isNecessaryTagSpecial={false}
        initialData={loaderData}
        onFormSubmit={onFormSubmit}
        namingPersistForm={formNaming.NEW_DUPLICATE_COMMUNICATION_FORM}
        namingTabsType={tabsType.DUPLICATE_COMMUNICATION}
      />
    </Container>
  );
}
